import { useRouteLoaderData } from 'react-router'
import { type loader as rootLoader } from '~/root'
import type { UserQueries } from './getUrlQueries.server'

export const useUserQueries = () => {
	const data = useRouteLoaderData<typeof rootLoader>('root')
	return data?.userQueries as UserQueries
}
